import { Model } from 'backbone';

/** This is intended to manage the search form to make it easier to track logic
in a single point
*/
export const FormModel = Model.extend({
  defaults: {
    transaction_type: '',
    description: ''
  }
});



// WEBPACK FOOTER //
// ./epayment_import/models/form.js